import { FC } from 'react'
import { FirmDetailsInvoiceData } from 'src/dtos/portal'
import {
  FirmViewSectionContainer,
  FlexDiv,
  OrangeButton,
  PastDueMessageContainer
} from '../index'
import { numberToCurrency } from 'src/utils/numberFormat'
import { format, isAfter } from 'date-fns'
import { useAuth } from 'src/context/auth'
import { GiPlainCircle } from 'react-icons/gi'
import { MdOpenInNew } from 'react-icons/md'

interface FirmViewInvoicesProps {
  invoiceData?: FirmDetailsInvoiceData;
  openInvoiceModal?: () => void;
}

const FirmViewInvoices: FC<FirmViewInvoicesProps> = ({ invoiceData, openInvoiceModal }) => {
  const { user } = useAuth()

  const isPastDue = user.role !== 'Client' ? false :
    (
      !invoiceData ? false :
        (
          !invoiceData?.currentPaymentDueDate ? false :
            isAfter(new Date(), new Date(invoiceData.currentPaymentDueDate))
        )
    )

  return (
    <FirmViewSectionContainer>
      <FlexDiv align='center' justify='space-between'>
        {(invoiceData && invoiceData?.policyKey) ? (
          <h1 style={{ color: user.role === 'Client' ? '#937251' : '#3D6666' }}>
            Invoice for Policy #{invoiceData?.policyKey}
          </h1>
        ) : null}
      </FlexDiv>
      {(invoiceData && invoiceData?.policyKey) ? (
        <>
          <FlexDiv dir='column' margin='32px 0 0'>
            <h5>CURRENT PAYMENT</h5>
            <hr style={{ marginTop: '8px' }} />
            <FlexDiv margin="24px 0 0 0">
              <FlexDiv dir='column' gap="22px">
                <article>
                  <h5>Total Due Now</h5>
                  {!!invoiceData.currentPaymentTotal ? (
                    <>
                      <h2 style={{ color: isPastDue ? '#E84242' : '#353744' }}>{numberToCurrency(invoiceData.currentPaymentTotal)}
                        <small> due {format(new Date(invoiceData.currentPaymentDueDate), 'MM/dd/yyyy')}</small>
                      </h2>
                      {isPastDue ? (
                        <PastDueMessageContainer>
                          <GiPlainCircle />
                          <span>PAST DUE</span>
                        </PastDueMessageContainer>
                      ) : null}
                    </>
                  ) : (
                    <h2>No current payment</h2>
                  )}
                </article>
              </FlexDiv>
              {user.role === 'Client' ? (
                <OrangeButton onClick={openInvoiceModal}>
                  Make a Payment in InvoiceCloud
                  <MdOpenInNew />
                </OrangeButton>
              ) : null}
            </FlexDiv>
          </FlexDiv>
          <FlexDiv dir='column' margin='106px 0 0'>
            <h5>NEXT PAYMENT</h5>
            <hr style={{ marginTop: '8px' }} />
            <FlexDiv margin="24px 0 0 0">
              <FlexDiv dir='column' gap="22px">
                <article>
                  <h5>Total Due Next</h5>
                  <h2>{invoiceData.nextPaymentTotal ? numberToCurrency(invoiceData.nextPaymentTotal) : 'N/A'}
                    <small> due {invoiceData.nextPaymentDueDate ? format(new Date(invoiceData.nextPaymentDueDate), 'MM/dd/yyyy') : 'N/A'}</small>
                  </h2>
                </article>
              </FlexDiv>
            </FlexDiv>
          </FlexDiv>
          <FlexDiv dir='column' margin='106px 0 0'>
            <h5>TOTAL REMAINING BALANCE</h5>
            <hr style={{ marginTop: '8px' }} />
            <FlexDiv margin="24px 0 0 0">
              <FlexDiv dir='column' gap="22px">
                <article>
                  <h5>Total Remaining Balance</h5>
                  <h2>{invoiceData.remainingBalance ? numberToCurrency(invoiceData.remainingBalance) : 'N/A'}</h2>
                </article>
              </FlexDiv>
            </FlexDiv>
          </FlexDiv>
          <FlexDiv dir='column' margin='88px 0 0'>
            <h5>PAYMENT HISTORY</h5>
            <hr style={{ marginTop: '8px' }} />
            <FlexDiv margin="24px 0 0 0">
              <FlexDiv dir='column' gap="22px">
                <article>
                  <h5>Total Contract Amount</h5>
                  <h6>{invoiceData.totalContractAmount ? numberToCurrency(invoiceData.totalContractAmount) : 'N/A'}</h6>
                </article>
              </FlexDiv>
              <FlexDiv dir='column' gap="22px">
                <article>
                  <h5>Total Paid</h5>
                  <h6>{invoiceData.totalPaid ? numberToCurrency(invoiceData.totalPaid) : 'N/A'}</h6>
                </article>
              </FlexDiv>
              <FlexDiv dir='column' gap="22px">
                <article>
                  <h5>Last Payment Amount</h5>
                  <h6>{invoiceData.lastPaymentTotal ? numberToCurrency(invoiceData.lastPaymentTotal) : 'N/A'}</h6>
                  {invoiceData.lastPaymentDueDate ? (
                    <span>{format(new Date(invoiceData.lastPaymentDueDate), 'MM/dd/yyyy')}</span>
                  ) : null}
                </article>
              </FlexDiv>
            </FlexDiv>
          </FlexDiv>
        </>
      ) : (invoiceData && !invoiceData?.policyKey) ? (
        <FlexDiv justify='center'>
          <OrangeButton onClick={openInvoiceModal}>
            Make a Payment in InvoiceCloud
            <MdOpenInNew />
          </OrangeButton>
        </FlexDiv>
      ) : (
        <h3>Loading...</h3>
      )}
    </FirmViewSectionContainer>
  )
}

export default FirmViewInvoices